"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _locales = require("@meepshop/locales");

var _useActivities = _interopRequireDefault(require("./hooks/useActivities"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/price.less");

var styles = {
  "root": "store-cart-previewer__previewer-price__root"
}; // graphql typescript

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var activityInfo = _ref.computedCart.activityInfo,
      productTotal = _ref.productTotal;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var _useContext2 = (0, _react.useContext)(_Currency["default"]),
      c = _useContext2.c;

  var _useTranslation = (0, _locales.useTranslation)('cart-previewer'),
      t = _useTranslation.t;

  var getLanguage = (0, _locales.useGetLanguage)();
  var activities = (0, _useActivities["default"])(activityInfo);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, t('product-total')), /*#__PURE__*/_react["default"].createElement("div", null, c(productTotal))), activities.map(function (_ref2) {
    var id = _ref2.id,
        title = _ref2.title,
        discountPrice = _ref2.discountPrice;
    return !discountPrice || discountPrice <= 0 ? null : /*#__PURE__*/_react["default"].createElement("div", {
      key: id
    }, /*#__PURE__*/_react["default"].createElement("div", null, getLanguage(title)), /*#__PURE__*/_react["default"].createElement("div", null, "- ", c(discountPrice)));
  })), /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            .".concat(styles.root, " {\n              color: ").concat(colors[3], ";\n              border-top-color: ").concat((0, _color["default"])(colors[5]).alpha(0.5), "\n            }\n          ")
    }
  }));
});

exports["default"] = _default;